import { useEffect, useRef } from "react";
import L from "leaflet";
import { MapContainer, TileLayer, Marker, useMap } from "react-leaflet";
import { CATEGORY_COLORS, CATEGORY_ICONS } from "@/lib/constants";

// Fix default marker icons (not used but avoid warnings)
delete L.Icon.Default.prototype._getIconUrl;

function makeIcon(category, ai) {
  const color = CATEGORY_COLORS[category] || "#c2a061";
  const emoji = CATEGORY_ICONS[category] || "•";
  const pulseCls = ai ? " ai-pulse" : "";
  return L.divIcon({
    className: "custom-marker-wrap",
    html: `<div class="map-marker${pulseCls}" style="background:${color};">${emoji}</div>`,
    iconSize: [28, 28],
    iconAnchor: [14, 14],
  });
}

function FlyController({ target }) {
  const map = useMap();
  useEffect(() => {
    if (target) {
      map.flyTo([target.lat, target.lng], Math.max(map.getZoom(), 5), { duration: 0.8 });
    }
  }, [target, map]);
  return null;
}

export default function WorldMap({ locations, onSelect, focus }) {
  const mapRef = useRef(null);

  return (
    <MapContainer
      center={[25, 10]}
      zoom={2.5}
      minZoom={2}
      maxZoom={18}
      worldCopyJump
      scrollWheelZoom
      className="absolute inset-0"
      ref={mapRef}
      style={{ height: "100%", width: "100%" }}
    >
      <TileLayer
        attribution='&copy; OpenStreetMap contributors &copy; CARTO'
        url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
        subdomains="abcd"
      />
      <FlyController target={focus} />
      {locations.map((loc) => (
        <Marker
          key={loc.id}
          position={[loc.lat, loc.lng]}
          icon={makeIcon(loc.category, loc.ai_generated)}
          eventHandlers={{ click: () => onSelect(loc) }}
        />
      ))}
    </MapContainer>
  );
}
